import { ResultQuickClickOption } from "./resultTypes";

/*
 * | Label       | Action Code     | Who         | OTHER      | Contact |
 * | ----------- | --------------- | ----------- | ---------- | ------- |
 * | IN2X        | IN              |             | 2X         | NONE    |
 * | INBSUPER    | IN              |             | BSUPER     | NONE    |
 * | INDA        | IN              |             | DA         | NONE    |
 * | INFML       | IN              | FML         |            | OTHER   |
 * | INHU        | IN              |             | HU         | NONE    |
 * | INMALE      | IN              | MALE        |            | OTHER   |
 * | INMBF       | IN              |             | MBF        | NONE    |
 * | INNA        | IN              |             | NA         | NONE    |
 * | INNML       | IN              |             | NML        | NONE    |
 * | INNOCALL    | IN              |             | NOCALL     | NONE    |
 * | INSYSMSG    | IN              |             | SYSMSG     | NONE    |
 * | INWRNG#     | IN              |             | WRNG#      | NONE    |
 * | LMAM        | LM              |             | AM         | NONE    |
 * | LMFML       | LM              | FML         |            | OTHER   |
 * | LMMALE      | LM              | MALE        |            | OTHER   |
 */
export const resultQuickClickOptions: ResultQuickClickOption[] = [
  {
    description: "IN2X",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "2X",
      contactPerson: "NONE",
    },
  },
  {
    description: "INBSUPER",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "BSUPER",
      contactPerson: "NONE",
    },
  },
  {
    description: "INDA",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "DA",
      contactPerson: "NONE",
    },
  },
  {
    description: "INFML",
    selections: {
      actionCode: "IN",
      contactDetail: "FML",
      other: null,
      contactPerson: "OTHER",
    },
  },
  {
    description: "INHU",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "HU",
      contactPerson: "NONE",
    },
  },
  {
    description: "INMALE",
    selections: {
      actionCode: "IN",
      contactDetail: "MALE",
      other: null,
      contactPerson: "OTHER",
    },
  },
  {
    description: "INMBF",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "MBF",
      contactPerson: "NONE",
    },
  },
  {
    description: "INNA",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "NA",
      contactPerson: "NONE",
    },
  },
  {
    description: "INNML",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "NML",
      contactPerson: "NONE",
    },
  },
  {
    description: "INNOCALL",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "NOCALL",
      contactPerson: "NONE",
    },
  },
  {
    description: "INSYSMSG",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "SYSMSG",
      contactPerson: "NONE",
    },
  },
  {
    description: "INWRNG#",
    selections: {
      actionCode: "IN",
      contactDetail: null,
      other: "WRNG#",
      contactPerson: "NONE",
    },
  },
  {
    description: "LMAM",
    selections: {
      actionCode: "LM",
      contactDetail: null,
      other: "AM",
      contactPerson: "NONE",
    },
  },
  {
    description: "LMFML",
    selections: {
      actionCode: "LM",
      contactDetail: "FML",
      other: null,
      contactPerson: "OTHER",
    },
  },
  {
    description: "LMMALE",
    selections: {
      actionCode: "LM",
      contactDetail: "MALE",
      other: null,
      contactPerson: "OTHER",
    },
  },
];
